<div class="section-popup">

    <p *ngIf="!sectionData.conclusion"
        [ghs-label]="(sectionData.marker ? 'scenario.section.addMarker' : 'scenario.section.add')  + (sectionData.hideIndex ? '' : 'Index')"
        [ghs-label-args]="[sectionData.index,  sectionData.marker || '']">
    </p>

    <p *ngIf="sectionData.conclusion" [ghs-label]="'scenario.section.conclusion'"
        [ghs-label-args]="[sectionData.name ? gameManager.scenarioManager.scenarioTitle(sectionData,true)  : '%scenario.section% #' + sectionData.index]">
    </p>

    <div class="buttons">
        <a class="cancel" (click)="close(false)"><span [ghs-label]="'scenario.section.cancel'"></span></a>
        <span class="spacer"></span>
        <a class="add" (click)="addSection()"><span [ghs-label]="'scenario.section.confirm'"></span></a>
    </div>
</div>